import type { CSSObject } from "@emotion/react";
import type { SxProps, Theme } from "@mui/material/styles";

import { MUI_FILLED_FIELD } from "./muiFilledFieldStyles";
import { buildMuiFilledInputRootStyles } from "./muiFilledFieldStyles";

export const muiFilledInputLabelSx: SxProps<Theme> = {
  overflow: "visible",
  transform: "translate(1.2rem, 1.4rem) scale(1)",
};

export const muiFilledSelectMultiWrapperClassName =
  "relative [&_.MuiSelect-select:before:disabled]:opacity-0 [&_.MuiSelect-select:focus]:bg-transparent";

export const muiFilledSelectWrapperClassName = "relative [&_.MuiSelect-select:focus]:bg-transparent";

export const dropdownCheckboxSx: SxProps<Theme> = {
  "&:hover": { bgcolor: "transparent" },
};

export const dropdownMenuItemTextSx: CSSObject = {
  color: MUI_FILLED_FIELD.fgPrimary,
  marginLeft: "0.25rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

type DropdownMenuItemStyleOptions = {
  compact?: boolean;
  focusBackground?: string;
  grouped?: boolean;
};

type MuiFilledSelectRootSxOptions = {
  borderColor?: string;
  disabledTextColor?: string;
  hasValue?: boolean;
  height?: string;
};

export function getDropdownMenuItemSx({
  compact = false,
  focusBackground = MUI_FILLED_FIELD.surfaceBright,
  grouped = false,
}: DropdownMenuItemStyleOptions = {}): CSSObject {
  return {
    "&:focus:not(:hover)": {
      backgroundColor: focusBackground,
    },
    "&:hover": {
      backgroundColor: MUI_FILLED_FIELD.selectionSubtle,
    },
    backgroundColor: MUI_FILLED_FIELD.surfaceBright,
    marginLeft: compact ? "4px" : "0.25rem",
    marginRight: compact ? "4px" : "0.25rem",
    ...(compact ? { minHeight: "auto" } : {}),
    padding: compact ? (grouped ? "0.3rem 1.5rem" : "0.3rem 0") : grouped ? "1rem 1.5rem" : "1rem",
  };
}

export function getDropdownMenuPropsSx(
  menuWidth?: number,
  selectedTone: "strong" | "subtle" = "strong"
): SxProps<Theme> {
  return {
    "&& .Mui-selected:not(:hover)": {
      backgroundColor: selectedTone === "strong" ? MUI_FILLED_FIELD.selectionStrong : MUI_FILLED_FIELD.selectionSubtle,
    },
    "& .MuiPaper-root": {
      backgroundColor: MUI_FILLED_FIELD.surfaceBright,
      borderRadius: "var(--border-radius-0-5x)",
      padding: "0rem",
      ...(menuWidth ? { width: `${menuWidth}px !important` } : {}),
    },
  };
}

export function getMuiFilledSelectRootSx({
  borderColor,
  disabledTextColor = MUI_FILLED_FIELD.fgMuted,
  hasValue = false,
  height = "4rem",
}: MuiFilledSelectRootSxOptions = {}): SxProps<Theme> {
  return buildMuiFilledInputRootStyles({
    borderColor: borderColor ?? (hasValue ? MUI_FILLED_FIELD.borderAccent : MUI_FILLED_FIELD.borderStrong),
    disabledTextColor,
    focusBorder: "accent",
    height,
  });
}
